import { render, staticRenderFns } from "./select-multiple-rq.vue?vue&type=template&id=2f1a2b52"
import script from "./select-multiple-rq.vue?vue&type=script&lang=js"
export * from "./select-multiple-rq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports